/* Event pages: the enter-to-win form (sections/event-entry.liquid) and booth kiosk mode. Deferred, once-guarded.
   QR codes are drawn by assets/event-qr.js.

   Entries go straight from the browser to Klaviyo's client API with the public key (the flow the StrongNY and
   Cheers landers used): 1. profiles/ writes the entry (name, phone, event properties); 2. subscriptions/ records
   email marketing consent and adds the profile to the event list. No SMS consent is asked for or recorded.

   Kiosk mode (?kiosk=1, for the booth iPad): autofill is off so the next entrant never sees the last one's email, the
   form resets itself after each entry, and when the venue wifi drops an entry is kept on the iPad (localStorage) and
   sent as soon as the connection is back. Off the kiosk a failed entry shows an error instead, so nobody leaves
   believing they entered when they didn't. */
(function () {
  if (window.KenetikEvent) return;
  window.KenetikEvent = true;

  var d = document;
  var params = new URLSearchParams(location.search);
  var kiosk = params.get('kiosk') === '1';
  if (kiosk) d.documentElement.classList.add('event-kiosk');

  var API = 'https://a.klaviyo.com/client/';
  var REVISION = '2026-07-15';
  var TIMEOUT = 12000;
  var QUEUE = 'kx-event-queue';
  var FAILED = 'kx-event-failed';

  /* ---------- Klaviyo ---------- */
  function post(pk, path, body) {
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, TIMEOUT) : null;
    return fetch(API + path + '?company_id=' + encodeURIComponent(pk), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: REVISION },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      clearTimeout(timer);
      return r.text().then(function (text) {
        if (r.ok) return text;
        var e = new Error(path + ' ' + r.status);
        e.status = r.status; e.body = text;
        throw e;
      });
    }, function (e) { clearTimeout(timer); throw e; });
  }

  /* Offline, timed out, rate limited or a Klaviyo outage: worth sending again later. Anything else is a real rejection. */
  function retryable(e) { return !e || !e.status || e.status === 429 || e.status >= 500; }

  function prune(obj, pointer) {
    var parts = String(pointer).split('/').filter(Boolean), cur = obj;
    for (var i = 0; i < parts.length - 1; i++) {
      if (cur == null || typeof cur !== 'object') return false;
      cur = cur[parts[i]];
    }
    var last = parts[parts.length - 1];
    if (cur && typeof cur === 'object' && Object.prototype.hasOwnProperty.call(cur, last)) { delete cur[last]; return true; }
    return false;
  }

  /* A 400 naming one optional field (Klaviyo rejects some phone numbers) drops that field and retries, so an entrant is
     never lost over formatting. The number is also kept in the entry_phone property. Email is never dropped. */
  function send(pk, path, body, tries) {
    tries = tries || 0;
    return post(pk, path, body).catch(function (e) {
      if (e.status !== 400 || tries >= 3) throw e;
      var ptr = null;
      try { ptr = JSON.parse(e.body).errors[0].source.pointer; } catch (x) {}
      if (ptr && !/email/.test(ptr) && prune(body, ptr)) {
        console.warn('[event] Klaviyo rejected ' + ptr + ', sent again without it');
        return send(pk, path, body, tries + 1);
      }
      throw e;
    });
  }

  function submitEntry(entry) {
    return send(entry.pk, 'profiles/', { data: { type: 'profile', attributes: entry.attrs } }).then(function () {
      return send(entry.pk, 'subscriptions/', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: entry.source,
            profile: { data: { type: 'profile', attributes: { email: entry.attrs.email } } }
          },
          relationships: { list: { data: { type: 'list', id: entry.list } } }
        }
      }).catch(function (e) {
        if (retryable(e)) throw e;
        /* The entry itself is on the profile (event properties); only the list add / consent failed. */
        console.warn('[event] entry saved, but the list add failed (' + e.status + '). Add this profile to list ' + entry.list + ' by hand.', e.body);
      });
    });
  }

  /* ---------- Kiosk queue ---------- */
  function read(key) { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } }
  function write(key, list) { try { localStorage.setItem(key, JSON.stringify(list)); return true; } catch (e) { return false; } }

  var flushing = false;
  function flush() {
    if (flushing) return;
    var q = read(QUEUE);
    showQueue(q.length);
    if (!q.length || navigator.onLine === false) return;
    flushing = true;
    submitEntry(q[0]).then(function () {
      return true;
    }, function (e) {
      if (retryable(e)) return false;
      var failed = read(FAILED); failed.push(q[0]); write(FAILED, failed);
      console.error('[event] Klaviyo rejected a saved entry; kept under localStorage "' + FAILED + '"', e.status, e.body);
      return true;
    }).then(function (sent) {
      flushing = false;
      if (!sent) return;
      var now = read(QUEUE); now.shift(); write(QUEUE, now);
      flush();
    });
  }

  function showQueue(n) {
    d.querySelectorAll('[data-event-queue]').forEach(function (el) {
      if (!kiosk || !n) { el.hidden = true; return; }
      el.textContent = (el.getAttribute('data-template') || '[count] waiting to send').replace('[count]', n);
      el.hidden = false;
    });
  }

  /* ---------- Form ---------- */
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v); }

  /* Optional phone, normalised to E.164 for Klaviyo. US numbers unless the entrant typed a +country code; anything we
     can't resolve is an error rather than a silently dropped value. */
  function e164(v) {
    var raw = String(v || '').trim();
    if (!raw) return '';
    var digits = raw.replace(/\D/g, '');
    if (raw.charAt(0) === '+' && digits.length >= 11 && digits.length <= 15) return '+' + digits;
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    return null;
  }

  function init(root) {
    var form = root.querySelector('[data-event-form]');
    if (!form) return;
    var cfg = root.dataset;
    var view = root.querySelector('[data-event-form-view]');
    var success = root.querySelector('[data-event-success]');
    var head = root.querySelector('[data-event-success-head]');
    var alertEl = root.querySelector('[data-event-alert]');
    var btn = form.querySelector('[type="submit"]');
    var btnLabel = btn.textContent;
    var next = root.querySelector('[data-event-next]');
    var countdown = root.querySelector('[data-event-countdown]');
    var f = { first: form.elements.first_name, last: form.elements.last_name, email: form.elements.email, phone: form.elements.phone };
    var timer = null;

    if (kiosk) {
      form.setAttribute('autocomplete', 'off');
      Object.keys(f).forEach(function (k) { if (f[k]) f[k].setAttribute('autocomplete', 'off'); });
      if (next) next.hidden = false;
    }

    function setInvalid(el, bad) {
      if (!el) return;
      var msg = d.getElementById(el.id + '-error');
      if (bad) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
      if (msg) msg.hidden = !bad;
    }
    Object.keys(f).forEach(function (k) {
      if (f[k]) f[k].addEventListener('input', function () { setInvalid(f[k], false); });
    });

    function busy(on) {
      btn.disabled = on;
      btn.textContent = on ? (btn.getAttribute('data-busy-label') || btnLabel) : btnLabel;
    }

    function showAlert(text) {
      alertEl.textContent = text;
      alertEl.hidden = !text;
    }

    function done() {
      var name = f.first.value.trim();
      var tpl = head.getAttribute('data-template') || head.textContent;
      head.textContent = name ? tpl.replace('[name]', name) : tpl.replace(/,?\s*\[name\]/, '');
      view.hidden = true;
      success.hidden = false;
      head.focus({ preventScroll: true });
      root.scrollIntoView({ block: 'start' });

      var data = { event_name: cfg.eventName, lead_source: leadSource() };
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'event_entry' }, data)); } catch (e) {}
      try { if (window.gtag) window.gtag('event', 'generate_lead', data); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('kenetik_event_entry', data); } catch (e) {}

      if (kiosk) startCountdown();
    }

    function startCountdown() {
      var left = parseInt(cfg.reset, 10) || 8;
      var label = countdown ? countdown.getAttribute('data-template') || '' : '';
      function tick() {
        if (countdown) { countdown.textContent = label.replace('[s]', left); countdown.hidden = false; }
        if (left-- <= 0) { reset(); return; }
        timer = setTimeout(tick, 1000);
      }
      tick();
    }

    function reset() {
      clearTimeout(timer);
      form.reset();
      Object.keys(f).forEach(function (k) { setInvalid(f[k], false); });
      showAlert('');
      busy(false);
      if (countdown) countdown.hidden = true;
      success.hidden = true;
      view.hidden = false;
      window.scrollTo(0, 0);
    }
    if (next) next.addEventListener('click', reset);

    function leadSource() { return kiosk ? 'event_kiosk' : (params.get('src') || 'event_page'); }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      showAlert('');

      var first = f.first.value.trim();
      var last = f.last ? f.last.value.trim() : '';
      var email = f.email.value.trim().toLowerCase();
      var phone = f.phone ? e164(f.phone.value) : '';
      var bad = [];
      if (!first) bad.push(f.first);
      if (!validEmail(email)) bad.push(f.email);
      if (phone === null) bad.push(f.phone);
      Object.keys(f).forEach(function (k) { setInvalid(f[k], bad.indexOf(f[k]) !== -1); });
      if (bad.length) { bad[0].focus(); return; }

      if (!cfg.pk || !cfg.list) {
        showAlert(alertEl.getAttribute('data-setup') || 'This form is not connected yet.');
        console.error('[event] set the Klaviyo public key and list ID in the section settings');
        return;
      }

      var props = {
        lead_source: leadSource(),
        event_name: cfg.eventName || '',
        giveaway: cfg.giveaway || '',
        entry_phone: phone || ''
      };
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) { if (params.get(k)) props[k] = params.get(k); });
      if (cfg.entryKey) props[cfg.entryKey] = new Date().toISOString();

      var attrs = { email: email, first_name: first, properties: props };
      if (last) attrs.last_name = last;
      if (phone) attrs.phone_number = phone;
      var entry = { pk: cfg.pk, list: cfg.list, source: cfg.source || cfg.eventName || 'Event page', attrs: attrs };

      busy(true);
      var sending = kiosk && navigator.onLine === false ? Promise.reject(new Error('offline')) : submitEntry(entry);
      sending.then(done, function (err) {
        if (kiosk && retryable(err)) {
          var q = read(QUEUE); q.push(entry);
          if (write(QUEUE, q)) { showQueue(q.length); done(); return; }
        }
        busy(false);
        console.error('[event] entry failed', err && err.status, err && err.body);
        showAlert((alertEl.getAttribute('data-error') || 'That did not go through. Please try again.') + (err && err.status ? ' (' + err.status + ')' : ''));
      });
    });
  }

  function start() {
    d.querySelectorAll('[data-event-entry]').forEach(init);
    if (kiosk) {
      flush();
      window.addEventListener('online', flush);
      setInterval(flush, 30000);
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
